import React from "react";
import Loginheader from "../../components/loginheader/Loginheader";
import { useContext, useEffect, useState } from "react";
import { FaUser, FaUniversity, FaMapMarkerAlt, FaGraduationCap, FaFileAlt, FaFilePdf } from 'react-icons/fa';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Modal, Row, Select, Spin } from 'antd';
import Icon from "../../assests/sidebar-icon.png";
import Plusicon from "../../assests/plus.png";
import Preview from "../../assests/preview.png"; // Add this icon to your assets
import { AuthContext } from "../../context/AuthContext";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toast } from "react-bootstrap";
import confetti from 'canvas-confetti';


const { Option } = Select;

// Add confetti library - you'll need to install it: npm install canvas-confetti
// For now, creating a mock function to prevent errors

export default function ViewProfileBack({ candidateid }) {
    const [preOnboardData, setPreOnboardData] = useState({});
    const [fileData, setFileData] = useState({});
    const [showSideBar, setShowSideBar] = useState(false);
    const [activeSection, setActiveSection] = useState("personal");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);

    // Missing state variables
    const [onboardRemarks, setOnboardRemarks] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [docUrl, setDocUrl] = useState("");
    const [docType, setDocType] = useState("");
    const [loading, setLoading] = useState(false);

    const { authData, backUrl } = useContext(AuthContext);
    const { cid } = useParams();

    const [addEducation, setAddEducation] = useState(1);
    const [addCareer, setAddCareer] = useState(1);
    const [addReference, setAddReference] = useState(1);

    const [errors, setErrors] = useState({});

    // Missing function for document preview
    const handleOpen = (documentUrl) => {
        const fileExtension = documentUrl.split('.').pop().toLowerCase();
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

        setDocUrl(documentUrl);
        setDocType(imageExtensions.includes(fileExtension) ? 'image' : 'pdf');
        setShowModal(true);
    };

    // Missing function for preview
    const handlePreview = async () => {

        try {
            const res = await axios.get(`${backUrl}/api/emp/preview-offer/${candidateid}/`, {
                responseType: "blob",
            });

            const url = URL.createObjectURL(res.data);
            window.open(url, "_blank");
            setTimeout(() => URL.revokeObjectURL(url), 100000);
        } catch (err) {
            console.error("Error previewing offer letter:", err);
        }
    };

    const submitFormData = async () => {
        // if (!validateForm()) {
        //     console.log("Validation failed");
        //     return;
        // }

        setIsSubmitting(true);

        try {
            const formData = new FormData();

            Object.keys(preOnboardData).forEach(key => {
                const value = preOnboardData[key];
                if (value !== null && value !== undefined && value !== '') {
                    if (Array.isArray(value) || typeof value === 'object') {
                        formData.append(key, JSON.stringify(value));
                    } else {
                        formData.append(key, value);
                    }
                }
            });

            Object.keys(fileData).forEach(key => {
                if (fileData[key]) {
                    formData.append(key, fileData[key]);
                }
            });

            console.log("Submitting to:", `${backUrl}/api/emp/candidate-preonboarding-form/${preOnboardData.submission_token}/`);

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }

            const res = await axios.put(
                `${backUrl}/api/emp/candidate-preonboarding-form/${preOnboardData.submission_token}/`,
                formData
            );

            console.log(res.data)

            toast.success(res.data.message || "Form submitted successfully!");
        } catch (error) {
            const errMsg =
                error.response?.data?.message ||
                error.response?.data?.error || // fallback if backend uses "error"
                "Error submitting form. Please try again.";

            console.error("Error submitting form:", errMsg);
            toast.error(errMsg, {
                position: "top-center",
                autoClose: 3000,
            });
        }
        finally {
            setIsSubmitting(false);
        }
    };

    const ConvertEmployee = () => {
        const [departments, setDepartments] = useState([]);
        const [designations, setDesignations] = useState([]);
        const [organizations, setOrganizations] = useState([]);
        const [employees, setEmployees] = useState([]);
        const [formData, setFormData] = useState({
            organisation: "",
            department: "",
            designation: "",
            reporting_to: "",
            total_casual_leave: 0,
            total_earned_leave: 0,
            total_sick_leave: 0,
        });
        const [loading, setLoading] = useState(false);
        const [showConvertModal, setShowConvertModal] = useState(false);
        const [errors, setErrors] = useState({});

        const fetchDepartments = async () => {
            try {
                const res = await axios.get(`${backUrl}/api/emp/departments/`);
                setDepartments(res.data.results);
            } catch (err) {
                console.error("Failed to fetch departments:", err);
            }
        };

        const fetchOrganizations = async () => {
            try {
                const res = await axios.get(`${backUrl}/api/emp/organisations/`);
                setOrganizations(res.data.results);
            } catch (err) {
                console.error("Failed to fetch organizations:", err);
            }
        };

        const fetchDesignations = async (departmentId) => {
            if (!departmentId) return;
            try {
                const res = await axios.get(`${backUrl}/api/emp/designations/?department=${departmentId}`);
                setDesignations(res.data.results);
            } catch (err) {
                console.error("Error fetching designations", err);
            }
        };

        const fetchEmployees = async (designationId) => {
            if (!designationId) return;
            try {
                const res = await axios.get(`${backUrl}/api/emp/employees/?designation=${designationId}`);
                setEmployees(res.data.results);
            } catch (err) {
                console.error("Error fetching employees", err);
            }
        };

        useEffect(() => {
            fetchOrganizations();
            fetchDepartments();
        }, []);

        const handleChange = (name, value) => {
            setFormData((prev) => ({ ...prev, [name]: value }));
        };

        const onClickSubmit = async () => {
            setLoading(true);
            try {
                const res = await axios.patch(
                    `${backUrl}/api/emp/convert-to-employee/${candidateid}/`,
                    formData,
                    { headers: { Authorization: `Bearer ${authData?.access}` } }
                );

                toast.success("Employee converted successfully!", {
                    position: "top-center",
                    autoClose: 2000,
                });

                // 🎉 Confetti
                const duration = 3000;
                const animationEnd = Date.now() + duration;
                const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 2000 };

                const interval = setInterval(() => {
                    const timeLeft = animationEnd - Date.now();
                    if (timeLeft <= 0) return clearInterval(interval);

                    const particleCount = 50 * (timeLeft / duration);

                    confetti({
                        ...defaults,
                        particleCount,
                        origin: { x: Math.random(), y: Math.random() - 0.2 },
                        colors: ["#ff0a54", "#ffff47", "#72ff70", "#85efff", "#d2b1fb", "#f9c1be", "#ffffff", "#ffd700"],
                    });

                    confetti({
                        ...defaults,
                        particleCount: 20,
                        scalar: 0.6,
                        shapes: ["star"],
                        origin: { x: Math.random(), y: Math.random() - 0.2 },
                        colors: ["#ffffff", "#ffd700"],
                    });
                }, 200);

                // wait for confetti to finish before closing modal
                setTimeout(() => {
                    setShowConvertModal(false);
                }, duration);

            } catch (err) {
                console.error("Error converting employee:", err);

                let errorMessage = "Conversion failed. Please check all fields.";
                if (err.response?.data) {
                    const data = err.response.data;
                    if (typeof data === "string") errorMessage = data;
                    else if (data.message) errorMessage = data.message;
                    else if (data.error) errorMessage = data.error;
                    else errorMessage = Object.values(data).flat().join(", ");
                }

                toast.error(errorMessage, { position: "top-center", autoClose: 3000 });
            } finally {
                setLoading(false);
            }
        };




        return (
            <>
                <button
                    onClick={() => setShowConvertModal(true)}
                    style={{
                        padding: "5px",
                        background: "linear-gradient(90deg, green)",
                        color: "white",
                        border: "none",
                        borderRadius: 6,
                        fontSize: 15,
                        fontWeight: 500,
                        cursor: "pointer",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                >
                    <CheckCircleOutlined /> Convert Employee
                </button>

                {showConvertModal && (
                    <>
                        <Spin spinning={loading} tip="Converting..." />
                        <Card bodyStyle={{ padding: 24 }}>
                            <h5 style={{ textAlign: "center", marginBottom: 20 }}>Convert Employee</h5>

                            <Form layout="vertical">
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item label="Organization">
                                            <Select
                                                placeholder="-- Select --"
                                                value={formData.organisation}
                                                onChange={(val) => handleChange("organisation", val)}
                                                style={{ width: "100%" }}
                                            >
                                                <Option value="">-- Select --</Option>
                                                {organizations.map((org) => (
                                                    <Option key={org.id} value={org.id}>
                                                        {org.name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item label="Department">
                                            <Select
                                                placeholder="-- Select --"
                                                value={formData.department}
                                                onChange={(val) => {
                                                    handleChange("department", val);
                                                    fetchDesignations(val);
                                                    handleChange("designation", "");
                                                    setDesignations([]);
                                                    setEmployees([]);
                                                    handleChange("reporting_to", "");
                                                }}
                                                style={{ width: "100%" }}
                                            >
                                                <Option value="">-- Select --</Option>
                                                {departments.map((dept) => (
                                                    <Option key={dept.id} value={dept.id}>
                                                        {dept.name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item label="Designation">
                                            <Select
                                                placeholder="-- Select --"
                                                value={formData.designation}
                                                onChange={(val) => {
                                                    handleChange("designation", val);
                                                    fetchEmployees(val);
                                                    setEmployees([]);
                                                    handleChange("reporting_to", "");
                                                }}
                                                style={{ width: "100%" }}
                                                disabled={!formData.department}
                                            >
                                                <Option value="">-- Select --</Option>
                                                {designations.map((des) => (
                                                    <Option key={des.id} value={des.id}>
                                                        {des.name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item label="Reporting To">
                                            <Select
                                                placeholder="-- Select --"
                                                value={formData.reporting_to}
                                                onChange={(val) => handleChange("reporting_to", val)}
                                                style={{ width: "100%" }}
                                                disabled={!formData.designation}
                                            >
                                                <Option value="">-- Select --</Option>
                                                {employees.map((emp) => (
                                                    <Option key={emp.id} value={emp.emp_code}>
                                                        {emp.first_name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item label="Casual Leave">
                                            <input
                                                className="w-100"
                                                type="number"
                                                name="total_casual_leave"
                                                value={formData.total_casual_leave}
                                                onChange={(e) => handleChange("total_casual_leave", e.target.value)}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item label="Earned Leave">
                                            <input
                                                className="w-100"
                                                type="number"
                                                name="total_earned_leave"
                                                value={formData.total_earned_leave}
                                                onChange={(e) => handleChange("total_earned_leave", e.target.value)}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item label="Sick Leave">
                                            <input
                                                className="w-100"
                                                type="number"
                                                name="total_sick_leave"
                                                value={formData.total_sick_leave}
                                                onChange={(e) => handleChange("total_sick_leave", e.target.value)}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>

                            <center>
                                <button className="p-3 text-light" onClick={onClickSubmit}>
                                    <CheckCircleOutlined /> Convert
                                </button>
                            </center>
                        </Card>
                    </>
                )}
            </>
        );
    };

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        if (type === 'file') {
            setFileData((prev) => ({
                ...prev,
                [name]: files[0]
            }));
        } else {
            setPreOnboardData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const fetchCandidateData = async () => {
        try {
            if (!candidateid) {
                console.warn("candidateid is missing");
                return;
            }

            const url = `${backUrl}/api/emp/candidate/?candidate_id=${candidateid}`;
            console.log("Fetching candidate with ID:", candidateid);

            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${authData?.access}` },
            });

            setPreOnboardData(res.data.results[0]);
            console.log("Candidate Data:", res.data.results[0]);
        } catch (error) {
            if (error.response) {
                console.error("API Error:", error.response.status, error.response.data);
                toast.error(`Error ${error.response.status}: ${error.response.data?.detail || "Failed to fetch candidate"}`);
            } else if (error.request) {
                console.error("No response from server:", error.request);
                toast.error("No response from server. Please try again.");
            } else {
                console.error("Error:", error.message);
                toast.error("Unexpected error occurred.");
            }
        }
    };

    useEffect(() => {
        fetchCandidateData();
    }, [])

    const handleEducationChange = (index, field, value) => {
        setPreOnboardData((prev) => {
            const updatedData = { ...prev };

            if (!updatedData.education_history) {
                updatedData.education_history = [];
            }

            if (!updatedData.education_history[index]) {
                updatedData.education_history[index] = {};
            }

            updatedData.education_history[index][field] = value;
            return updatedData;
        });
    };

    const handleCareerChange = (index, field, value) => {
        setPreOnboardData((prev) => {
            const updatedData = { ...prev };

            if (!updatedData.career_history) {
                updatedData.career_history = [];
            }

            if (!updatedData.career_history[index]) {
                updatedData.career_history[index] = {};
            }

            updatedData.career_history[index][field] = value;
            return updatedData;
        });
    };

    const handleReferenceChange = (index, field, value) => {
        setPreOnboardData((prev) => {
            const updatedData = { ...prev };

            if (!updatedData.reference_history) {
                updatedData.reference_history = [];
            }

            if (!updatedData.reference_history[index]) {
                updatedData.reference_history[index] = {};
            }

            updatedData.reference_history[index][field] = value;
            return updatedData;
        });
    };

    const validateForm = () => {
        const requiredFields = [
            'initial', 'first_name', 'last_name', 'mobile_number', 'email_id',
            'aadhaar', 'pan', 'date_of_birth', 'place_of_birth', 'mother_tongue',
            'gender', 'blood_group', 'emergency_contact_person', 'emergency_contact_number',
            'bank_account_number', 'ifsc_code', 'uan_number', 'branch_name',
            'address', 'area', 'city', 'state', 'country', 'pincode'
        ];

        const newErrors = {};

        requiredFields.forEach(field => {
            if (!preOnboardData[field] || preOnboardData[field].toString().trim() === '') {
                newErrors[field] = 'This field is required';
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };



    const handleSectionSelect = (section) => {
        setActiveSection(section);
        setShowSideBar(false);
    };


    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

            <div className="mt-5">
                {!isEditMode ? (
                    <button
                        className="btn btn-primary"
                        onClick={() => setIsEditMode(true)}
                    >
                        Edit Form
                    </button>
                ) : (
                    <>
                        <button
                            className="btn btn-success"
                            onClick={submitFormData}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Updating..." : "Update Form"}
                        </button>
                        <button
                            className="btn btn-secondary mx-3"
                            onClick={() => {
                                setIsEditMode(false);
                                fetchCandidateData(); // Reset form to original data
                            }}
                        >
                            Cancel
                        </button>
                    </>
                )}
            </div>


            {/* <a className="mb-2 ms-3 bg-light" onClick={() => setShowSideBar(!showSideBar)}>
                <img
                    id="show-icon1"
                    className={showSideBar ? "rotate mb-2 ms-3" : "mb-2 ms-3"}
                    src={Icon}
                    alt="Toggle Sidebar"
                />
            </a> */}
            {/* Sidebar */}
            {showSideBar && (
                <div id="sidebar-view" className={showSideBar ? "active" : ""}>
                    <div className="sidebar-content">
                        <ul>
                            <li onClick={() => handleSectionSelect("personal")}>Personal Details</li>
                            <li onClick={() => handleSectionSelect("bank")}>Bank Details</li>
                            <li onClick={() => handleSectionSelect("address")}>Address Details</li>
                            <li onClick={() => handleSectionSelect("education")}>Education Details</li>
                            <li onClick={() => handleSectionSelect("documents")}>Documents</li>
                        </ul>
                    </div>
                </div>
            )}

            {/* Top buttons for large screens */}
            <div id="show-container1" className="container mt-4 mb-4">
                <div className="row justify-content-center">
                    {[
                        { key: "personal", label: "Personal Details", icon: <FaUser /> },
                        { key: "bank", label: "Bank Details", icon: <FaUniversity /> },
                        { key: "address", label: "Address Details", icon: <FaMapMarkerAlt /> },
                        { key: "education", label: "Education Details", icon: <FaGraduationCap /> },
                        { key: "documents", label: "Documents", icon: <FaFileAlt /> },
                    ].map((item, index, arr) => (
                        <div className="col text-center position-relative" key={item.key}>
                            <div
                                className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    backgroundColor: activeSection === item.key ? "#0d6efd" : "#e9ecef",
                                    color: activeSection === item.key ? "#fff" : "#6c757d",
                                    zIndex: 1,
                                    cursor: "pointer"
                                }}
                                onClick={() => setActiveSection(item.key)}
                            >
                                {item.icon}
                            </div>
                            <small
                                className={activeSection === item.key ? "text-primary fw-bold" : "text-muted"}
                                style={{ cursor: "pointer" }}
                                onClick={() => setActiveSection(item.key)}
                            >
                                {item.label}
                            </small>
                        </div>
                    ))}
                </div>
                <hr />
            </div>

            <center>
                <p style={{ color: "#d32f2f", marginBottom: "16px" }}>
                    * Indicates required fields
                </p>
            </center>

            {/* Section rendering */}
            <div className="section-content">
                {activeSection === "personal" && (
                    <>
                        <center><h2 className="mb-5">Personal Details</h2></center>

                        <div className="container px-4">
                            <div className="row gy-4">
                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label>Initial <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="initial" value={preOnboardData.initial || ""} onChange={handleChange} placeholder="Initial" required />
                                        {errors.initial && <p style={{ color: 'red', fontSize: '12px' }}>{errors.initial}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>First Name <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="first_name" value={preOnboardData.first_name || ""} onChange={handleChange} placeholder="Name" required />
                                        {errors.first_name && <p style={{ color: 'red', fontSize: '12px' }}>{errors.first_name}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Last Name <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="last_name" value={preOnboardData.last_name || ""} onChange={handleChange} placeholder="Name" required />
                                        {errors.last_name && <p style={{ color: 'red', fontSize: '12px' }}>{errors.last_name}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Mobile Number <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="mobile_number" value={preOnboardData.mobile_number || ""} onChange={handleChange} placeholder="Mobile Number" required />
                                        {errors.mobile_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.mobile_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Email Id <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="email" name="email_id" value={preOnboardData.email_id || ""} onChange={handleChange} placeholder="Email Id" required />
                                        {errors.email_id && <p style={{ color: 'red', fontSize: '12px' }}>{errors.email_id}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Aadhaar No <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="number" name="aadhaar" value={preOnboardData.aadhaar || ""} onChange={handleChange} placeholder="Aadhaar No" required />
                                        {errors.aadhaar && <p style={{ color: 'red', fontSize: '12px' }}>{errors.aadhaar}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>PAN No <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="pan" value={preOnboardData.pan || ""} onChange={handleChange} placeholder="Pan number" required />
                                        {errors.pan && <p style={{ color: 'red', fontSize: '12px' }}>{errors.pan}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Date Of Birth <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="date" name="date_of_birth" value={preOnboardData.date_of_birth || ""} onChange={handleChange} required />
                                        {errors.date_of_birth && <p style={{ color: 'red', fontSize: '12px' }}>{errors.date_of_birth}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Place Of Birth <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="place_of_birth" value={preOnboardData.place_of_birth || ""} onChange={handleChange} placeholder="place of birth" required />
                                        {errors.place_of_birth && <p style={{ color: 'red', fontSize: '12px' }}>{errors.place_of_birth}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Mother Tongue <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="mother_tongue" value={preOnboardData.mother_tongue || ""} onChange={handleChange} placeholder="Mother Tongue" required />
                                        {errors.mother_tongue && <p style={{ color: 'red', fontSize: '12px' }}>{errors.mother_tongue}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            Gender <span style={{ color: "#d32f2f" }}>*</span>
                                        </label>
                                        <select
                                            name="gender"
                                            value={preOnboardData.gender || ""}
                                            onChange={handleChange}
                                            required
                                            style={{ width: "100%", padding: "8px" }}
                                        >
                                            <option value="">-- Select Gender --</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        {errors.gender && (
                                            <p style={{ color: "red", fontSize: "12px" }}>{errors.gender}</p>
                                        )}
                                    </div>

                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="form-group">
                                        <label>Religion</label>
                                        <input type="text" name="religion" value={preOnboardData.religion || ""} onChange={handleChange} placeholder="Religion" />
                                    </div>

                                    <div className="form-group">
                                        <label>Blood Group <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="blood_group" value={preOnboardData.blood_group || ""} onChange={handleChange} placeholder="Blood group" required />
                                        {errors.blood_group && <p style={{ color: 'red', fontSize: '12px' }}>{errors.blood_group}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Height</label>
                                        <input type="text" name="height" value={preOnboardData.height || ""} onChange={handleChange} placeholder="Height" />
                                    </div>

                                    <div className="form-group">
                                        <label>Weight</label>
                                        <input type="text" name="weight" value={preOnboardData.weight || ""} onChange={handleChange} placeholder="weight" />
                                    </div>

                                    <div className="form-group">
                                        <label>Marital Status</label>
                                        <select name="marital_status" value={preOnboardData.marital_status || ""} onChange={handleChange}>
                                            <option value="">Select Option</option>
                                            <option value="Married">Married</option>
                                            <option value="Unmarried">Unmarried</option>
                                        </select>
                                    </div>

                                    {preOnboardData.marital_status === "Married" && (
                                        <>
                                            <div className="form-group">
                                                <label>Wedding Date</label>
                                                <input type="date" name="wedding_date" value={preOnboardData.wedding_date || ""} onChange={handleChange} />
                                            </div>

                                            <div className="form-group">
                                                <label>Spouse Name</label>
                                                <input type="text" name="spouse_name" value={preOnboardData.spouse_name || ""} onChange={handleChange} placeholder="Spouse Name" />
                                            </div>

                                            <div className="form-group">
                                                <label>Spouse DOB</label>
                                                <input type="date" name="spouse_dob" value={preOnboardData.spouse_dob || ""} onChange={handleChange} />
                                            </div>
                                        </>
                                    )}

                                    <div className="form-group">
                                        <label>Emergency Contact Person <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="emergency_contact_person" value={preOnboardData.emergency_contact_person || ""} onChange={handleChange} placeholder="Contact Person" required />
                                        {errors.emergency_contact_person && <p style={{ color: 'red', fontSize: '12px' }}>{errors.emergency_contact_person}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Emergency Contact Number <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input type="text" name="emergency_contact_number" value={preOnboardData.emergency_contact_number || ""} onChange={handleChange} placeholder="Contact Number" required />
                                        {errors.emergency_contact_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.emergency_contact_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Father's Name</label>
                                        <input type="text" name="father_name" value={preOnboardData.father_name || ""} onChange={handleChange} placeholder="Father Name" />
                                    </div>

                                    <div className="form-group">
                                        <label>Father's Profession</label>
                                        <input type="text" name="father_profession" value={preOnboardData.father_profession || ""} onChange={handleChange} placeholder="Father Profession" />
                                    </div>

                                    <div className="form-group">
                                        <label>Mother's Name</label>
                                        <input type="text" name="mother_name" value={preOnboardData.mother_name || ""} onChange={handleChange} placeholder="Mother Name" />
                                    </div>

                                    <div className="form-group">
                                        <label>Mother's Profession</label>
                                        <input type="text" name="mother_profession" value={preOnboardData.mother_profession || ""} onChange={handleChange} placeholder="Mother Profession" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <center><button className="text-light p-2 py-1" onClick={() => setActiveSection("bank")}>Next</button></center>
                    </>
                )}

                {activeSection === "bank" && (
                    <>
                        <center><h2 className="mb-5">Bank Details</h2></center>
                        <center>
                            <div id="bank-area" className="container row px-4">
                                <div className="col-12 col-md-6 p-2">
                                    <div className="form-group">
                                        <label>Bank Account Number <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="bank_account_number"
                                            value={preOnboardData.bank_account_number || ""}
                                            onChange={handleChange}
                                            placeholder="Bank Account No"
                                            required
                                        />
                                        {errors.bank_account_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.bank_account_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>IFSC Code <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="ifsc_code"
                                            value={preOnboardData.ifsc_code || ""}
                                            onChange={handleChange}
                                            placeholder="IFSC Code"
                                            required
                                        />
                                        {errors.ifsc_code && <p style={{ color: 'red', fontSize: '12px' }}>{errors.ifsc_code}</p>}
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 p-2">
                                    <div className="form-group">
                                        <label>UAN Number <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="uan_number"
                                            value={preOnboardData.uan_number || ""}
                                            onChange={handleChange}
                                            placeholder="UAN no"
                                            required
                                        />
                                        {errors.uan_number && <p style={{ color: 'red', fontSize: '12px' }}>{errors.uan_number}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Branch Name <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="branch_name"
                                            value={preOnboardData.branch_name || ""}
                                            onChange={handleChange}
                                            placeholder="Branch Name"
                                            required
                                        />
                                        {errors.branch_name && <p style={{ color: 'red', fontSize: '12px' }}>{errors.branch_name}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between w-100 px-3 px-md-5">
                                <button className="text-light p-2 py-1" onClick={() => setActiveSection("personal")}>
                                    Previous
                                </button>
                                <button className="text-light p-2 py-1" onClick={() => setActiveSection("address")}>
                                    Next
                                </button>
                            </div>

                        </center>
                    </>
                )}

                {activeSection === "address" && <>
                    <center><h2 className="mb-5">Address Details</h2></center>
                    {/* <center>
                        <div className="container ms-5 mb-3">
                            <label className="me-3">Permanent Address</label>
                            <div>
                                <label className="me-3">
                                    <input
                                        type="radio"
                                        name="permanent_address"
                                        value="yes"
                                        checked={preOnboardData.permanent_address === "yes"}
                                        onChange={handleChange}
                                    /> Yes
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="permanent_address"
                                        value="no"
                                        checked={preOnboardData.permanent_address === "no"}
                                        onChange={handleChange}
                                    /> No
                                </label>
                            </div>
                        </div>
                    </center> */}

                    <center>
                        <div id="address-area" className="container row px-4">
                            <div className="col-12 col-md-6 p-2">
                                <div className="form-group">
                                    <label>Address <span style={{ color: "#d32f2f" }}>*</span></label>
                                    <textarea
                                        name="address_for_communication"
                                        className="form-control"
                                        value={preOnboardData.address_for_communication || ""}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                    {errors.address_for_communication && <p style={{ color: 'red', fontSize: '12px' }}>{errors.address_for_communication}</p>}
                                </div>


                                <div className="form-group">
                                    <label>Area <span style={{ color: "#d32f2f" }}>*</span></label>
                                    <input
                                        type="text"
                                        name="area"
                                        className="form-control"
                                        value={preOnboardData.area || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                    {errors.area && <p style={{ color: 'red', fontSize: '12px' }}>{errors.area}</p>}
                                </div>

                                <div className="form-group">
                                    <label>City <span style={{ color: "#d32f2f" }}>*</span></label>
                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control"
                                        value={preOnboardData.city || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                    {errors.city && <p style={{ color: 'red', fontSize: '12px' }}>{errors.city}</p>}
                                </div>
                            </div>

                            <div className="col-12 col-md-6 p-2">
                                <div className="form-group">
                                    <label>State <span style={{ color: "#d32f2f" }}>*</span></label>
                                    <input
                                        type="text"
                                        name="state"
                                        className="form-control"
                                        value={preOnboardData.state || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                    {errors.state && <p style={{ color: 'red', fontSize: '12px' }}>{errors.state}</p>}
                                </div>

                                <div className="form-group">
                                    <label>Country <span style={{ color: "#d32f2f" }}>*</span></label>
                                    <input
                                        type="text"
                                        name="country"
                                        className="form-control"
                                        value={preOnboardData.country || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                    {errors.country && <p style={{ color: 'red', fontSize: '12px' }}>{errors.country}</p>}
                                </div>

                                <div className="form-group">
                                    <label>Pincode <span style={{ color: "#d32f2f" }}>*</span></label>
                                    <input
                                        type="number"
                                        name="pincode"
                                        className="form-control"
                                        value={preOnboardData.pincode || ""}
                                        onChange={handleChange}
                                        required
                                    />
                                    {errors.pincode && <p style={{ color: 'red', fontSize: '12px' }}>{errors.pincode}</p>}
                                </div>
                            </div>

                            <div>
                                <label>Permanent Address</label>
                                <input
                                    type="checkbox"
                                    name="permanent_address"
                                    checked={preOnboardData.permanent_address === "yes"}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setPreOnboardData((prev) => ({
                                                ...prev,
                                                permanent_address: "yes",
                                                permanent_address_for_communication: prev.address_for_communication,
                                                permanent_area: prev.area,
                                                permanent_city: prev.city,
                                                permanent_state: prev.state,
                                                permanent_country: prev.country,
                                                permanent_pincode: prev.pincode,
                                            }));
                                        } else {
                                            setPreOnboardData((prev) => ({
                                                ...prev,
                                                permanent_address: "no",
                                                permanent_address_for_communication: "",
                                                permanent_area: "",
                                                permanent_city: "",
                                                permanent_state: "",
                                                permanent_country: "",
                                                permanent_pincode: "",
                                            }));
                                        }
                                    }}
                                />{" "}
                                Yes
                            </div>

                            {/* Permanent Address */}
                            <h5>Permanent Address</h5>
                            <div id="address-area" className="container row px-4">
                                <div className="col-12 col-md-6 p-2">
                                    <div className="form-group">
                                        <label>Address <span style={{ color: "#d32f2f" }}>*</span></label>
                                        <textarea
                                            name="permanent_address_for_communication"
                                            className="form-control"
                                            value={preOnboardData.permanent_address_for_communication || ""}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                        {errors.permanent_address_for_communication && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_address_for_communication}</p>}
                                    </div>


                                    <div className="form-group">
                                        <label>Area<span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="permanent_area"
                                            className="form-control"
                                            value={preOnboardData.permanent_area || ""}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.permanent_area && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_area}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>City<span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="permanent_city"
                                            className="form-control"
                                            value={preOnboardData.permanent_city || ""}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.permanent_city && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_city}</p>}
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 p-2">
                                    <div className="form-group">
                                        <label>State<span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="permanent_state"
                                            className="form-control"
                                            value={preOnboardData.permanent_state || ""}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.permanent_state && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_state}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Country<span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="text"
                                            name="permanent_country"
                                            className="form-control"
                                            value={preOnboardData.permanent_country || ""}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.permanent_country && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_country}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Pincode<span style={{ color: "#d32f2f" }}>*</span></label>
                                        <input
                                            type="number"
                                            name="permanent_pincode"
                                            className="form-control"
                                            value={preOnboardData.permanent_pincode || ""}
                                            onChange={handleChange}
                                            required
                                        />
                                        {errors.permanent_pincode && <p style={{ color: 'red', fontSize: '12px' }}>{errors.permanent_pincode}</p>}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="d-flex justify-content-between w-100 px-3 px-md-5">
                            <button className="text-light p-2 py-1" onClick={() => setActiveSection("bank")}>Previous</button>
                            <button className="text-light p-2 py-1" onClick={() => setActiveSection("education")}>Next</button>
                        </div>
                    </center>
                </>
                }

                {activeSection === "education" && <>
                    <center><h2 className="mb-3">Academic Details</h2></center>

                    {/* Education History */}
                    <center>
                        <div className="container row mt-5">
                            <div className="col-12 col-md-4 px-4 py-1">
                                <div className="d-flex justify-content-around">
                                    <h4 className="mb-5">Education History </h4>
                                    {
                                        addEducation === 1 && (
                                            <img id="plus-icon" src={Plusicon} onClick={async () => {
                                                await setAddEducation(addEducation + 1)
                                                console.log(addEducation)
                                            }} />
                                        )
                                    }
                                </div>
                                {Array.from({ length: addEducation }, (_, index) => (
                                    <div key={index} className="card mt-3">
                                        {addEducation > 1 && (
                                            <div className="d-flex justify-content-between mb-4 p-4">
                                                <img className="mt-3" id="plus-icon" src={Plusicon} onClick={async () => {
                                                    await setAddEducation(addEducation + 1)
                                                    console.log(addEducation)
                                                }} />
                                                <p className="mt-3" onClick={() => setAddEducation(addEducation - 1)}>❌</p>
                                            </div>)}
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label">Educational Qualification <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="educational_qualification"
                                                    className="form-control"
                                                    value={preOnboardData.education_history?.[index]?.educational_qualification || ""}
                                                    onChange={(e) => handleEducationChange(index, 'educational_qualification', e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Institution Name <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="educational_institution_name"
                                                    className="form-control"
                                                    value={preOnboardData.education_history?.[index]?.educational_institution_name || ""}
                                                    onChange={(e) => handleEducationChange(index, 'educational_institution_name', e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Degree / Diploma <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="degree_or_diploma"
                                                    className="form-control"
                                                    value={preOnboardData.education_history?.[index]?.degree_or_diploma || ""}
                                                    onChange={(e) => handleEducationChange(index, 'degree_or_diploma', e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">From <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="date"
                                                    name="course_duration_from"
                                                    className="form-control"
                                                    value={preOnboardData.education_history?.[index]?.course_duration_from || ""}
                                                    onChange={(e) => handleEducationChange(index, 'course_duration_from', e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">To <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="date"
                                                    name="course_duration_to"
                                                    className="form-control"
                                                    value={preOnboardData.education_history?.[index]?.course_duration_to || ""}
                                                    onChange={(e) => handleEducationChange(index, 'course_duration_to', e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Career History */}
                            <div className="col-12 col-md-4 p-4">
                                <div className="d-flex justify-content-around">
                                    <h4 className="mb-5">Career History </h4>
                                    {
                                        addCareer === 1 && (
                                            <img id="plus-icon" src={Plusicon} onClick={async () => {
                                                await setAddCareer(addCareer + 1)
                                                console.log(addCareer)
                                            }} />
                                        )
                                    }
                                </div>

                                {Array.from({ length: addCareer }, (_, index) => (
                                    <div key={index} className="card mt-3">
                                        {addCareer > 1 && (
                                            <div className="d-flex justify-content-between mb-4 p-4">
                                                <img className="mt-3" id="plus-icon" src={Plusicon} onClick={async () => {
                                                    await setAddCareer(addCareer + 1)
                                                    console.log(addCareer)
                                                }} />
                                                <p className="mt-3" onClick={() => setAddCareer(addCareer - 1)}>❌</p>
                                            </div>)}
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label">Company Name <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="organisation"
                                                    className="form-control"
                                                    value={preOnboardData.career_history?.[index]?.organisation || ""}
                                                    onChange={(e) => handleCareerChange(index, 'organisation', e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Designation <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="designation"
                                                    className="form-control"
                                                    value={preOnboardData.career_history?.[index]?.designation || ""}
                                                    onChange={(e) => handleCareerChange(index, 'designation', e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">From <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="date"
                                                    name="work_duration_from"
                                                    className="form-control"
                                                    value={preOnboardData.career_history?.[index]?.work_duration_from || ""}
                                                    onChange={(e) => handleCareerChange(index, 'work_duration_from', e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">To <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="date"
                                                    name="work_duration_to"
                                                    className="form-control"
                                                    value={preOnboardData.career_history?.[index]?.work_duration_to || ""}
                                                    onChange={(e) => handleCareerChange(index, 'work_duration_to', e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Key Responsibilities <span style={{ color: "#d32f2f" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    name="keyresponsibilities"
                                                    className="form-control"
                                                    value={preOnboardData.career_history?.[index]?.keyresponsibilities || ""}
                                                    onChange={(e) => handleCareerChange(index, 'keyresponsibilities', e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Reference History */}
                            {/* Reference History */}
                            <div className="col-12 col-md-4 p-4">
                                <div className="d-flex justify-content-around">
                                    <h4 className="mb-5">Reference History </h4>
                                    {addReference === 1 && (
                                        <img
                                            id="plus-icon"
                                            src={Plusicon}
                                            onClick={async () => {
                                                await setAddReference(addReference + 1);
                                                console.log(addReference);
                                            }}
                                        />
                                    )}
                                </div>

                                {Array.from({ length: addReference }, (_, index) => (
                                    <div key={index} className="card mt-3">
                                        {addReference > 1 && (
                                            <div className="d-flex justify-content-between mb-4 p-4">
                                                <img
                                                    className="mt-3"
                                                    id="plus-icon"
                                                    src={Plusicon}
                                                    onClick={async () => {
                                                        await setAddReference(addReference + 1);
                                                        console.log(addReference);
                                                    }}
                                                />
                                                <p className="mt-3" onClick={() => setAddReference(addReference - 1)}>❌</p>
                                            </div>
                                        )}

                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Reference Name <span style={{ color: "#d32f2f" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="referal_name"
                                                    className="form-control"
                                                    value={preOnboardData.reference_history?.[index]?.referal_name || ""}
                                                    onChange={(e) => handleReferenceChange(index, "referal_name", e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Reference Designation <span style={{ color: "#d32f2f" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="referal_desgination"
                                                    className="form-control"
                                                    value={preOnboardData.reference_history?.[index]?.referal_desgination || ""}
                                                    onChange={(e) => handleReferenceChange(index, "referal_desgination", e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Reference Mobile <span style={{ color: "#d32f2f" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="referal_mobile_number"
                                                    className="form-control"
                                                    value={preOnboardData.reference_history?.[index]?.referal_mobile_number || ""}
                                                    onChange={(e) => handleReferenceChange(index, "referal_mobile_number", e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Reference Email Id <span style={{ color: "#d32f2f" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="referal_email_id"
                                                    className="form-control"
                                                    value={preOnboardData.reference_history?.[index]?.referal_email_id || ""}
                                                    onChange={(e) => handleReferenceChange(index, "referal_email_id", e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between w-100 px-3 px-md-5">
                            <button className="text-light p-2 py-1" onClick={() => setActiveSection("address")}>Previous</button>
                            <button className="text-light p-2 py-1" onClick={() => setActiveSection("documents")}>Next</button>
                        </div>
                    </center>
                </>
                }

                {activeSection === "documents" && preOnboardData && (
                    <>
                        <center>
                            <h2 className="mb-3">Onboard Documents</h2>
                        </center>

                        <div className="container d-flex flex-wrap justify-content-between mt-4 px-2">
                            {/* Left Column: Personal Details */}
                            <div className="p-4 col-12 col-md-4">
                                <h5 className="mt-2">Personal Documents</h5>

                                {preOnboardData.aadhar_card_copy && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.aadhar_card_copy)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Aadhaar Card</span>
                                    </div>
                                )}

                                {preOnboardData.bank_account_details && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.bank_account_details)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Bank Details</span>
                                    </div>
                                )}
                                {preOnboardData.pan_card_copy && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.pan_card_copy)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Pan Card</span>
                                    </div>
                                )}
                                {preOnboardData.covid_certificate && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.covid_certificate)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Covid Certificate</span>
                                    </div>
                                )}
                            </div>

                            {/* Middle Column: Educational Documents */}
                            <div className="p-4 col-12 col-md-4">
                                <h5 className="mt-2">Educational Documents</h5>

                                {preOnboardData.SSLC && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.SSLC)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>SSLC</span>
                                    </div>
                                )}

                                {preOnboardData.HSC_diploma_ITI && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.HSC_diploma_ITI)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>HSC / Diploma / ITI</span>
                                    </div>
                                )}

                                {preOnboardData.PG_Phd && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.PG_Phd)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>PG / PhD</span>
                                    </div>
                                )}

                                {preOnboardData.degree_certificate && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.degree_certificate)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Degree Certificate</span>
                                    </div>
                                )}
                            </div>

                            {/* Right Column: Employment Documents */}
                            <div className="p-4 col-12 col-md-4">
                                <h5 className="mt-2">Employment Documents</h5>

                                {preOnboardData.previous_experience_letter && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.previous_experience_letter)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Experience Letter</span>
                                    </div>
                                )}
                                {preOnboardData.last_three_month_payslip && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.last_three_month_payslip)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Three Months Payslip</span>
                                    </div>
                                )}
                                {preOnboardData.last_three_months_account_statement && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.last_three_months_account_statement)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Three Months Account Statement</span>
                                    </div>
                                )}
                                {preOnboardData.releiving_letter && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.releiving_letter)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Releiving Letter</span>
                                    </div>
                                )}
                                {preOnboardData.offer_letter && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.offer_letter)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Offer Letter</span>
                                    </div>
                                )}

                                {preOnboardData.appointment_letter && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.appointment_letter)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Appointment Letter</span>
                                    </div>
                                )}

                                {preOnboardData.bank_account_details && (
                                    <div
                                        className="mb-3 d-flex align-items-center cursor-pointer"
                                        onClick={() => handleOpen(preOnboardData.bank_account_details)}
                                    >
                                        <FaFilePdf className="me-2 text-danger" />
                                        <span>Bank Account Details</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Ant Design Modal */}
                        {/* <Modal
                            open={showModal}
                            onCancel={() => setShowModal(false)}
                            footer={null}
                            width={800}
                            centered
                            bodyStyle={{ padding: 0 }}
                        >
                            {docType === "image" ? (
                                <img
                                    src={docUrl}   // ✅ use state instead of hard-coding
                                    alt="Document"
                                    style={{ maxWidth: "100%", height: "auto" }}
                                />
                            ) : (
                                <iframe
                                    src={docUrl}   // ✅ use state instead of hard-coding
                                    title="Document Viewer"
                                    style={{ width: "100%", height: "600px", border: "none" }}
                                />
                            )}
                        </Modal> */}

                        <ToastContainer
                            position="top-right"
                            autoClose={3000}  // close after 3s
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            pauseOnHover
                            draggable
                            theme="colored"
                        />

                        <center>
                            <div>
                                <button
                                    className="text-light p-2 py-1"
                                    onClick={() => setActiveSection("education")}
                                >
                                    Previous
                                </button>
                            </div>
                            <br />


                            <Button
                                type="text"
                                onClick={handlePreview}
                                loading={loading}
                                icon={<img src={Preview} alt="preview" className="icon" />}
                                className="m-3"
                                id="bread"
                            >
                                Preview
                            </Button>


                            {
                                authData.employee.is_superuser ? (
                                    <>
                                        <div>
                                            <textarea name="hr_candidate_remarks" value={onboardRemarks} onChange={(e) => setOnboardRemarks(e.target.value)}></textarea>
                                        </div>

                                        <button
                                            onClick={async () => {
                                                try {
                                                    const formData = new FormData();
                                                    formData.append("hr_candidate_remarks", onboardRemarks);
                                                    formData.append("hr_approve_status", true);

                                                    const res = await axios.post(
                                                        `${backUrl}/api/emp/candidate/${candidateid}/hr-approve/`,
                                                        formData,
                                                        {
                                                            headers: {
                                                                Authorization: `Bearer ${authData?.access}`,
                                                                "Content-Type": "multipart/form-data",
                                                            },
                                                        }
                                                    );
                                                    console.log(res.data);
                                                    toast.success("Profile Verified Successfully");
                                                    setOnboardRemarks("");
                                                } catch (err) {
                                                    console.error(err);
                                                    toast.error("Failed to verify profile");
                                                }
                                            }}
                                            className="btn btn-success p-1"
                                        >
                                            Verified
                                        </button>

                                        <button
                                            onClick={async () => {
                                                try {
                                                    const formData = new FormData();
                                                    formData.append("hr_candidate_remarks", onboardRemarks);
                                                    formData.append("hr_approve_status", false);

                                                    const res = await axios.post(
                                                        `${backUrl}/api/emp/candidate/${candidateid}/hr-approve/`,
                                                        formData,
                                                        {
                                                            headers: {
                                                                Authorization: `Bearer ${authData?.access}`,
                                                                "Content-Type": "multipart/form-data",
                                                            },
                                                        }
                                                    );

                                                    console.log(res.data);
                                                    toast.error("Profile Rejected");
                                                    setOnboardRemarks("");
                                                } catch (err) {
                                                    console.error(err);
                                                    toast.error("Failed to reject profile");
                                                }
                                            }}
                                            className="btn btn-danger p-1 mx-2"
                                        >
                                            Rejected
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        {
                                            authData.employee.role === 1 && (
                                                <>
                                                    {
                                                        preOnboardData.document_verified_by === null ? (
                                                            <>
                                                                <div>
                                                                    <textarea name="onboard_hr_remarks" value={onboardRemarks} onChange={(e) => setOnboardRemarks(e.target.value)}></textarea>
                                                                </div>

                                                                <button
                                                                    onClick={async () => {
                                                                        try {
                                                                            const formData = new FormData();
                                                                            formData.append("onboard_hr_remarks", onboardRemarks);
                                                                            formData.append("background_verification_status", "Approved");
                                                                            formData.append("is_hr_view", 'True');

                                                                            const res = await axios.put(
                                                                                `${backUrl}/api/emp/candidate/${candidateid}/update-background-status/`,
                                                                                formData,
                                                                                {
                                                                                    headers: {
                                                                                        Authorization: `Bearer ${authData?.access}`,
                                                                                        "Content-Type": "multipart/form-data",
                                                                                    },
                                                                                }
                                                                            );

                                                                            console.log(res.data);
                                                                            toast.success("Profile Verified Successfully");
                                                                            setOnboardRemarks("");
                                                                        } catch (err) {
                                                                            console.error(err);
                                                                            toast.error("Failed to verify profile");
                                                                        }
                                                                    }}
                                                                    className="btn btn-success p-1"
                                                                >
                                                                    Profile Verified
                                                                </button>

                                                                <button
                                                                    onClick={async () => {
                                                                        try {
                                                                            const formData = new FormData();
                                                                            formData.append("onboard_hr_remarks", onboardRemarks);
                                                                            formData.append("background_verification_status", "Rejected");

                                                                            const res = await axios.put(
                                                                                `${backUrl}/api/emp/candidate/${candidateid}/update-background-status/`,
                                                                                formData,
                                                                                {
                                                                                    headers: {
                                                                                        Authorization: `Bearer ${authData?.access}`,
                                                                                        "Content-Type": "multipart/form-data",
                                                                                    },
                                                                                }
                                                                            );

                                                                            console.log(res.data);
                                                                            toast.error("Profile Rejected 🚫");
                                                                            setOnboardRemarks("");
                                                                        } catch (err) {
                                                                            console.error(err);
                                                                            toast.error("Failed to reject profile ❌");
                                                                        }
                                                                    }}
                                                                    className="btn btn-danger p-1 mx-2"
                                                                >
                                                                    Profile Rejected
                                                                </button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <p className="text-success" style={{ fontWeight: 'bolder' }}>Profile Already Verified!</p>
                                                            </>
                                                        )
                                                    }

                                                </>
                                            )
                                        }

                                        {
                                            authData.employee.role === 2 && (
                                                <>
                                                    {
                                                        preOnboardData.convert_to_employee === true ? (
                                                            <p className="text-success" style={{ fontWeight: 'bolder' }}>Candidate Already Converted!</p>
                                                        ) : (
                                                            <ConvertEmployee />
                                                        )
                                                    }


                                                </>
                                            )
                                        }

                                    </>
                                )
                            }



                        </center>

                    </>
                )}

            </div >
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
}